import { useEffect, useState } from 'react';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { attemptCloseGuestTab } from '../../shared/guestFlowComplete';
import './GuestCheckInCompleteModal.css';

export default function GuestCheckInCompleteModal({
  open,
  guestName = 'there',
  isNewMember = false,
  customerCode = '',
  services = [],
  warning = '',
  franchiseName = '',
  onClosed,
}) {
  const [closeHint, setCloseHint] = useState(false);

  useEffect(() => {
    if (!open) {
      setCloseHint(false);
      return undefined;
    }

    const timer = window.setTimeout(() => {
      const closed = attemptCloseGuestTab();
      if (!closed) setCloseHint(true);
    }, 2200);

    return () => window.clearTimeout(timer);
  }, [open]);

  if (!open) return null;

  const title = isNewMember ? `Welcome, ${guestName}!` : `Thank you, ${guestName}!`;
  const subtitle = isNewMember
    ? 'You are checked in. Our team will assist you shortly.'
    : 'Welcome back — you are checked in for today.';

  const handleClose = () => {
    const closed = attemptCloseGuestTab();
    if (!closed) setCloseHint(true);
    onClosed?.();
  };

  const serviceNames = (services || [])
    .map((s) => (typeof s === 'string' ? s : s?.name))
    .filter(Boolean);

  return (
    <div className="fi-guest-complete" role="dialog" aria-modal="true" aria-labelledby="fi-guest-complete-title">
      <div className="fi-guest-complete__backdrop" aria-hidden="true" />
      <div className="fi-guest-complete__card">
        <div className="fi-guest-complete__icon" aria-hidden="true">
          {isNewMember ? <Sparkles size={30} /> : <CheckCircle2 size={32} />}
        </div>
        <p className="fi-guest-complete__eyebrow">Check-in complete</p>
        <h2 id="fi-guest-complete-title" className="fi-guest-complete__title">
          {title}
        </h2>
        <p className="fi-guest-complete__lede">{subtitle}</p>

        {franchiseName ? (
          <p className="fi-guest-complete__outlet">
            <span>Outlet</span> {franchiseName}
          </p>
        ) : null}

        {customerCode ? (
          <div className="fi-guest-complete__code-wrap">
            <p className="fi-guest-complete__code-label">Your check-in code</p>
            <p className="fi-guest-complete__code" aria-live="polite">
              {customerCode}
            </p>
            <p className="fi-guest-complete__code-hint">Share this at the front desk if asked.</p>
          </div>
        ) : null}

        {serviceNames.length ? (
          <div className="fi-guest-complete__services">
            <p className="fi-guest-complete__services-label">Last taken services</p>
            <ul>
              {serviceNames.map((name) => (
                <li key={name}>{name}</li>
              ))}
            </ul>
          </div>
        ) : null}

        {warning ? <p className="fi-guest-complete__warning">{warning}</p> : null}

        <p className="fi-guest-complete__safe-note">
          For your privacy, please close this browser tab when you are done. Scanning the QR again will
          start a new check-in.
        </p>

        <button type="button" className="fi-guest-complete__btn" onClick={handleClose}>
          Close this window
        </button>

        {closeHint ? (
          <p className="fi-guest-complete__close-hint" role="status">
            You can now close this browser tab from your phone&apos;s tab switcher.
          </p>
        ) : null}
      </div>
    </div>
  );
}
